import { Box, Grid, Heading, Text, Image, VStack, HStack, Icon, Wrap, WrapItem } from '@chakra-ui/react';
import { Folder, Search, Plus, Circle, ArrowRight, ArrowLeft} from 'react-feather';
import { AuthProvider } from 'oidc-react';
import { useAuth } from 'oidc-react';
import { Link } from 'react-router-dom'; 

import { useLazyGetAllProjectStatesQuery } from '@/lib/api/GraphAPI';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setProjectState } from '@/lib/state/slices/ProjectStateSlice';
import { useAppDispatch } from '@/lib/hooks';

import { useDisclosure } from "@chakra-ui/react";
import { NewProjectModal } from "@/components/NewProjectModal";

export default function ProjectPage() {
    
    const arrow = ArrowLeft;
    const [
        getAllProjects,
        {data: projects, isSuccess, isLoading}
    ] = useLazyGetAllProjectStatesQuery();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const newProjectModal = useDisclosure();

    useEffect(() => {
        getAllProjects();},
        [getAllProjects]
    );
    
    return (
        <VStack w="100%" h="100%" p={10} gap={10} align="stretch">
            <HStack w="100%" justify="space-between">
                <HStack 
                    w="100%"
                    justify="start" 
                    gap={5}
                >
                    <Link to="/home">
                        <Icon 
                            as={arrow}
                            boxSize={10}
                            color="gray"
                            cursor="pointer"
                            transition="transform 0.4s ease"
                            _hover={{
                                transform: "scale(1.30)"
                            }}
                        />
                    </Link>
                    <Heading fontSize={30}>
                        Projects
                    </Heading>
                </HStack>

                <HStack 
                    borderRadius="30px" 
                    bg="accentButtonDefault" 
                    w={240} h={55}
                    justify="center"
                    cursor="pointer"
                    _hover={{
                        bg:"navButtonHover"
                    }}
                    onClick={() => newProjectModal.setOpen(true)}
                >
                    <Icon as={Plus} color="white" boxSize={8}></Icon>

                    <Text color="white" fontSize={18}>New Project</Text>
                </HStack>

            </HStack>

            <Wrap w="100%" gap={3} flex={1} overflowY="auto">
                {isLoading && <Text>Loading projects...</Text>}

                {isSuccess && 
                    projects?.map((project) => {

                        const folders = Object.values(
                                project.json.documents.structure.FOLDER ?? {}
                            );

                        return (
                            <WrapItem>
                            <VStack 
                                w={280} 
                                h={150} 
                                pl={5}
                                pt={3}
                                bg="white" 
                                borderRadius="10px" 
                                align="start"
                                cursor="pointer"
                                _hover={{
                                    shadow: "md",
                                    bg: "cardHover"
                                }}
                                onClick={() => {
                                    dispatch(setProjectState(project.json));
                                    navigate("/research");
                                }}
                            >
                                <Text 
                                    fontSize={18}
                                    color="accentButtonDefault"
                                >
                                    {project.json.name}
                                </Text>

                                {folders.slice(0, 2).map((folder: any) => (
                                    <HStack key={folder.id} gap={2.5}>
                                        <Box
                                            w="8px"
                                            h="8px"
                                            borderRadius="full"
                                            bg="secondaryText"
                                        />
                                        <Text color="secondaryText" fontSize={14}>
                                            {folder.name}
                                        </Text>
                                    </HStack>
                                ))}
                            </VStack>
                        </WrapItem>
                        )
                    })
                }

            </Wrap>

            <NewProjectModal
                open={newProjectModal.open}
                setOpen={newProjectModal.setOpen}
            />

        </VStack>
    );
}